<script>
  export let titleText = "Page Title";
  export let subtitleText = "";
  export let textColor = "";
  export let bgColor = "";
  export let bannerImg = "";
  export let bannerImgMobile = "";
  export let overlayColor = "var(--gray-100)";
  export let overlayOpacity = 0.6;
  export let titleFontSize = "";
  export let titleFontWeight = "";
  export let useOffset = true;
  export let iconPaths = [];

  const getBackgroundImageValue = (str) =>
    /\//.test(str) ? `url(${str})` : str;
</script>

<style lang="scss">:root {
  --white: #ffffff;
  --black: #090f20;
  --accent: #6be7ba;
  --gray-10: #fafbfb;
  --gray-20: #eaecee;
  --gray-30: #bcc2c7;
  --gray-40: #9fa6ac;
  --gray-50: #838b92;
  --gray-60: #697178;
  --gray-70: #51585e;
  --gray-80: #3b4045;
  --gray-90: #26292c;
  --gray-100: #121416;
  --blue-40: #074e67;
  --blue-50: #003850;
  --blue-60: #002448;
  --blue-70: #001440;
  --teal-10: #cce4e4;
  --teal-20: #9ac9ca;
  --teal-30: #68aeb0;
  --teal-40: #369396;
  --teal-50: #1d8689;
  --teal-60: #04797c;
  --teal-70: #036063;
  --teal-80: #02484a;
  --teal-90: #013031;
  --teal-100: #001818;
  --rs-green: #5dfa25;
  --rs-blue: #25c7fa;
  --rs-teal: #88dcc4;
  --card-gradient-01: linear-gradient(180deg, #187a45 0%, #125949 71.35%, #0d4034 97.4%);
  --card-gradient-02: linear-gradient(180deg, #197d7f 0%, #017f77 0.01%, #145066 72.92%, #0f3c4d 100%);
  --card-gradient-03: linear-gradient(180deg, #1f7799 0%, #195380 76.04%, #143466 100%);
  --gradient-gray-blue: linear-gradient(to bottom, #26292c 0%, #262b30 8.1%, #262e33 15.5%, #253037 22.5%, #25333b 29%, #24353f 35.3%, #233743 41.2%, #223a47 47.1%, #213c4b 52.9%, #1f3f4f 58.8%, #1d4153 64.7%, #1b4457 71%, #18465b 77.5%, #14495f 84.5%, #0f4b63 91.9%, #074e67 100%);
  --interactive-01: #04797c;
  --interactive-02: #002448;
  --interactive-03: #04797c;
  --interactive-04: #04797c;
  --ui-background: rgba(250, 251, 251, 0.5);
  --ui-01: #ffffff;
  --ui-02: #fafbfb;
  --ui-03: #eaecee;
  --ui-04: #838b92;
  --ui-05: #121416;
  --text-01: #121416;
  --text-02: #51585e;
  --text-03: #9fa6ac;
  --text-04: #ffffff;
  --icon-01: #121416;
  --icon-02: #51585e;
  --icon-03: #ffffff;
  --link-01: #015afe;
  --link-02: #0043ce;
  --field-01: #ffffff;
  --field-02: #fafbfb;
  --inverse-01: #ffffff;
  --inverse-02: #3b4045;
  --support-01: #df4759;
  --support-02: #24a148;
  --support-03: #fdd13a;
  --support-04: #04797c;
  --inverse-support-01: #fb4b53;
  --inverse-support-02: #3dbb61;
  --inverse-support-03: #fdd13a;
  --inverse-support-04: #9ac9ca;
  --overlay-01: rgba(23, 23, 23, 0.5);
  --focus: #002448;
  --hover-primary: #036063;
  --active-primary: #036063;
  --hover-primary-text: #121416;
  --hover-secondary: #003850;
  --active-secondary: #001440;
  --hover-tertiary: #04797c;
  --active-tertiary: #04797c;
  --hover-ui: #fafbfb;
  --active-ui: #bcc2c7;
  --selected-ui: #eaecee;
  --hover-selected-ui: #bcc2c7;
  --hover-danger: #ba1b23;
  --active-danger: #750e13;
  --hover-row: #fafbfb;
  --visited-link: #8a3ffc;
  --disabled-01: #ffffff;
  --disabled-02: #9ac9ca;
  --disabled-03: #51585e;
  --highlight: #c9deff;
  --skeleton-01: #eaecee;
  --skeleton-02: #bcc2c7;
  --active-01: #04797c;
  --hover-field: #e5e5e5;
  --box-shadow: 0 0.125rem 0.25rem rgba(9, 15, 32, 0.075);
  --box-shadow-lift: 0 1rem 2.5rem rgba(9, 15, 32, 0.1), 0 0.5rem 1rem -0.75rem rgba(9, 15, 32, 0.1);
  --border-radius: 0.175rem;
  --spacing-1: 0.0625rem;
  --spacing-2: 0.125rem;
  --spacing-4: 0.25rem;
  --spacing-8: 0.5rem;
  --spacing-12: 0.75rem;
  --spacing-16: 1rem;
  --spacing-24: 1.5rem;
  --spacing-32: 2rem;
  --spacing-40: 2.5rem;
  --spacing-48: 3rem;
  --spacing-64: 4rem;
  --spacing-96: 6rem;
  --spacing-160: 10rem;
  --p-default-max-width: 75ch;
  --p-lead-default-max-width: 55ch;
  --gcm-ACCESS1-0: #1f77b4;
  --gcm-CanESM2: #bcbd22;
  --gcm-CCSM4: #2ca02c;
  --gcm-CESM1-BGC: #8c564b;
  --gcm-CMCC-CMS: #e377c2;
  --gcm-CNRM-CM5: #17becf;
  --gcm-GFDL-CM3: #ff7f0e;
  --gcm-HadGEM2-CC: #454444;
  --gcm-HadGEM2-ES: #d62728;
  --gcm-MIROC5: #9467bd; }

.banner {
  min-height: 16rem;
  color: var(--white);
  background-image: var(--banner-img, none);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: var(--banner-bg-color, var(--gray-80));
  padding: var(--spacing-48) 0; }

@media (max-width: 42rem) {
  .banner {
    min-height: 14rem;
    background-image: var(--banner-img-mobile, var(--banner-img), none); } }

.banner--content {
  position: relative; }

.banner--content > * + * {
  margin-top: 1.5rem; }

.banner h1,
.banner p {
  color: var(--text-color, var(--white));
  line-height: 1.25; }

.banner h1 {
  font-size: var(--title-font-size, 2.625rem);
  font-weight: var(--title-font-weight, 600); }

.banner.bg-img p,
.banner.bg-img h1 {
  filter: drop-shadow(0px 1px 2px var(--gray-100)); }

.banner .lead {
  max-width: 56ch;
  font-weight: 400; }

.banner :global(.lead a) {
  color: var(--text-color, var(--white));
  text-decoration: solid underline var(--accent) 2px; }

.banner--icons {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem; }

.overlay::before {
  opacity: var(--overlay-opacity);
  background-color: var(--overlay-color); }
</style>

<div
  class="banner"
  class:bleed="{bannerImg}"
  class:bg-img="{bannerImg}"
  class:overlay="{overlayColor}"
  style="--banner-img:{getBackgroundImageValue(bannerImg)};
    --banner-img-mobile:{getBackgroundImageValue(bannerImgMobile)};
    --banner-bg-color:{bgColor};
    --overlay-color:{overlayColor};
    --overlay-opacity:{overlayOpacity};
    --title-font-size:{titleFontSize};
    --title-font-weight:{titleFontWeight};
    --text-color:{textColor}"
>
  <div class="bx--grid">
    <!-- optional icons row -->
    {#if Array.isArray(iconPaths) && iconPaths.length}
      <div class="bx--row">
        <div
          class="bx--col banner--icons"
          class:bx--offset-lg-2="{useOffset}"
          aria-hidden="true"
        >
          {#each iconPaths as path}
            <img src="{path}" alt="" class="icon" />
          {/each}
        </div>
      </div>
    {/if}

    <!-- main content row -->
    <div class="bx--row">
      <div
        class="banner--content bx--col-lg-10"
        class:bx--offset-lg-2="{useOffset}"
      >
        <h1>{titleText}</h1>

        <!-- subtitle text can be a single or multiple paragraphs -->
        {#if Array.isArray(subtitleText) && subtitleText.length}
          {#each subtitleText as textItem}
            <p class="lead">{@html textItem}</p>
          {/each}
        {:else}
          <p class="lead">{@html subtitleText}</p>
        {/if}

        <!-- optional slot for a CTA button -->
        <slot name="button" />
      </div>
      <div class="bx--col-lg-4 bx--offset-lg-2">
        <!-- optional slot for a CTA card -->
        <slot name="cta-card" />
      </div>
    </div>
  </div>
</div>
